import { render, staticRenderFns } from "./OnePlant.vue?vue&type=template&id=1123f394&scoped=true"
import script from "./OnePlant.vue?vue&type=script&lang=js"
export * from "./OnePlant.vue?vue&type=script&lang=js"
import style0 from "./OnePlant.vue?vue&type=style&index=0&id=1123f394&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1123f394",
  null
  
)

export default component.exports